import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";
import "../../styles/plans.css";

const Plans = () => {

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

  const navigate = useNavigate();

  const fetchPlans = async () => {
    try {
      const res = await API.get("/admin/plans");
      setPlans(res.data || []);
    } catch (err) {
      console.error("Fetch plans error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  // ================= TOGGLE ACTIVE =================
  const toggleStatus = async (planId) => {
    try {

      setUpdatingId(planId);

      const res = await API.patch(`/admin/plans/${planId}`);

      // update local state instead of refetch
      setPlans(prev =>
        prev.map(p =>
          p._id === planId ? res.data.plan : p
        )
      );

    } catch (err) {
      console.error("Toggle error:", err);
      alert("Failed to update status");
    } finally {
      setUpdatingId(null);
    }
  };

  // ================= TOGGLE POPULAR =================
  const togglePopular = async (planId) => {
    try {

      const res = await API.patch(`/admin/plans/${planId}/popular`);

      setPlans(prev =>
        prev.map(p =>
          p._id === planId ? res.data.plan : p
        )
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update popular");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="plans-container">

      <div className="plans-header">
        <h2>Plans</h2>

        <button
          className="add-btn"
          onClick={() => navigate("/admin/plans/add")}
        >
          + Add Plan
        </button>
      </div>

      <table className="plans-table">

        <thead>
          <tr>
            <th>Name</th>
            <th>Credits</th>
            <th>Price</th>
            <th>Description</th>
            <th>Popular</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {plans.length === 0 ? (
            <tr>
              <td colSpan="7">No plans found</td>
            </tr>
          ) : (
            plans.map((plan) => (
              <tr key={plan._id}>

                <td>{plan.name}</td>
                <td>{plan.credits}</td>
                <td>₹{plan.price}</td>

                <td>
                  {plan.description || "-"}
                </td>

                <td>
                  <button
                    className="popular-btn"
                    onClick={() => togglePopular(plan._id)}
                  >
                    {plan.isPopular ? "⭐ Yes" : "No"}
                  </button>
                </td>

                <td>
                  {plan.isActive ? (
                    <span className="active">Active</span>
                  ) : (
                    <span className="inactive">Inactive</span>
                  )}
                </td>

                <td>
                  <button
                    className="toggle-btn"
                    disabled={updatingId === plan._id}
                    onClick={() => toggleStatus(plan._id)}
                  >
                    {updatingId === plan._id
                      ? "Updating..."
                      : plan.isActive
                      ? "Deactivate"
                      : "Activate"}
                  </button>
                </td>

              </tr>
            ))
          )}
        </tbody>

      </table>

    </div>
  );
};

export default Plans;